import type Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Box, useDevice } from "@memorang/ui";
import { useTranslation } from "react-i18next";
import { Button } from "react-native-paper";

export type ReportCta = {
	label: string;
	icon?: keyof typeof Icon.glyphMap;
	loading?: boolean;
	onPress: () => void;
};

const BUTTON_HEIGHT = 48;

// Every slot is optional. All actions sit fit-width and right-aligned on desktop
// and stack full-width on mobile - the contained primary (test report's Review /
// Retake) never stretches; it sits beside Go home like any other action.
export const ProethicaReportFooter = ({
	primaryCta,
	retakeCta,
	handleGoHome,
	goHomePrimary,
}: {
	primaryCta?: ReportCta;
	retakeCta?: ReportCta;
	handleGoHome?: () => void;
	goHomePrimary?: boolean;
}) => {
	const { isMobile } = useDevice();
	const { t } = useTranslation();
	return (
		<Box
			flexDirection={isMobile ? "column" : "row"}
			alignItems="stretch"
			justifyContent="flex-end"
			style={{ gap: 12 }}
		>
			{primaryCta ? (
				<Button
					mode="contained"
					icon={primaryCta.icon}
					loading={primaryCta.loading}
					disabled={primaryCta.loading}
					onPress={primaryCta.onPress}
					contentStyle={{ height: BUTTON_HEIGHT }}
				>
					{primaryCta.label}
				</Button>
			) : null}
			{retakeCta ? (
				<Button
					mode="outlined"
					icon={retakeCta.icon}
					loading={retakeCta.loading}
					disabled={retakeCta.loading}
					onPress={retakeCta.onPress}
					contentStyle={{ height: BUTTON_HEIGHT }}
				>
					{retakeCta.label}
				</Button>
			) : null}
			{handleGoHome ? (
				<Button
					mode={goHomePrimary ? "contained" : "outlined"}
					icon="home-outline"
					onPress={handleGoHome}
					contentStyle={{ height: BUTTON_HEIGHT }}
				>
					{t("report.proethica.footer.goHome")}
				</Button>
			) : null}
		</Box>
	);
};
